import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
  content: {
    display: 'flex',
    gap: '16px',
  },
  warningIcon: {
    color: foundations.colors.yellow500,
    fontSize: '24px',
    flexShrink: 0,
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  dialogPaper: {
    overflow: 'visible',
  },
  dialogContent: {
    overflow: 'visible',
  },
  dropdownContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
});
